import { Button } from '@ds';
import { NEW_REPORT_NAME } from '@shared/constants';
import { REPORT_EDIT_MODES } from '@routes/constants/reports';
import { reportRoute } from '@routes/utils/reports';
import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { DSNotesIcon } from '@ds-icons';
import { BETA_FEATURE_REPORTS_NEW_DESIGN } from '@/lib/betaFeatures';
import useBetaFeatureEnabled from '@shared/hooks/useBetaFeatureEnabled';

interface NewReportButtonProps {
  canEdit: boolean;
}

const NewReportButton = ({ canEdit }: NewReportButtonProps) => {
  const { projectName, workspace: workspaceName } = useParams<{
    projectName: string;
    workspace: string;
  }>();
  const isReportsNewDesignEnabled = useBetaFeatureEnabled(
    BETA_FEATURE_REPORTS_NEW_DESIGN
  );

  const sharedProps = useMemo(
    () => ({
      editMode: REPORT_EDIT_MODES.EDIT,
      projectName,
      reportName: NEW_REPORT_NAME,
      workspaceName
    }),
    [projectName, workspaceName]
  );

  const legacyReportUrl = reportRoute(sharedProps);
  const newDesignReportUrl = reportRoute({
    ...sharedProps,
    isReportsNewDesign: true
  });

  const renderLegacyLink = () => (
    <Link to={legacyReportUrl}>
      <Button disabled={!canEdit} PrefixIcon={<DSNotesIcon />}>
        {`New report${isReportsNewDesignEnabled ? ' (Legacy)' : ''}`}
      </Button>
    </Link>
  );

  if (!isReportsNewDesignEnabled) {
    return renderLegacyLink();
  }

  return (
    <div style={{ display: 'flex', gap: 12 }}>
      {renderLegacyLink()}
      <Link to={newDesignReportUrl}>
        <Button disabled={!canEdit} PrefixIcon={<DSNotesIcon />}>
          New report (V2)
        </Button>
      </Link>
    </div>
  );
};

export default NewReportButton;
